shadow$provide[129] = function(require,module,exports) {
var require$_DOT__SLASH_MultiRenderer = require("./MultiRenderer");
var require$_DOT__SLASH_VRRenderer = require("./VRRenderer");

};